export default{enter:"w_Bl",bottomLeft:"w_Bm",bottomRight:"w_Bn",topLeft:"w_Bo",topRight:"w_Bp",enterActive:"w_Bq",exit:"w_Br",exitActive:"w_Bs"};
